export enum ErrorsB2C {
    'B2C_User_Cancellation' = 'AADB2C90091',
    'B2C-User-No-Oid' = 'User-No-Oid',
    'B2C-User-No-Permission' = 'User-No-Permission',
    'B2C-Environment-Forbidden' = 'Environment-Forbidden',
    'B2C-Server-Failed' = 'AADB2C90075',
    'B2C-User-Email-Invalid' = 'AADB2C90157'
}